<template>
	<div class="container">
		<div class="content" v-html="article.content"></div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Survey',
		data() {
			return {
				article:""
			}
		},
		methods: {

		},
		mounted() {
			var that = this;
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://xs.weapi.org/cms";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://xs.weapi.org/cms";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/cms";
			}
			that.baseUrl = baseUrl;
			that.articleid = that.$route.query.articleid;
			wclient.view.showLoading();
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "GET",
				url: baseUrl+"/ajax?ugi=article&action=get&moduleid=PORTAL&articleid=e69f26cf725847ee9462eb7d1e7b68f6",
				dataType: "json",
				async: true,
				data: {
					
				},
				success: function(data) {
					if(data.code=='A00006'){
						wclient.view.hideLoading();
						that.article=data.article;
					}
				}
			});
		}
	}
</script>

<style scoped>

	.container {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.banner {
		width: 100%;
		float: left;
	}
	.content{
		float: left;
		width: 100%;
	}
	.content >>> p{
		width: 90%;
		overflow: hidden;
		margin: 10px 5%;
		font-size: 16px;
	}
	.content >>> div{
		width: 90%;
		margin: 10px 5%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.content >>> div>img{
		width: 5% !important;
		margin-right: 10px;
	}
	.content >>> p:nth-child(1){
		width: 100%;
		overflow: hidden;
		margin: 10px 0;
		font-size: 18px;
		margin-top: 0;
	}
	.content >>> img{
		width: 100% !important;
		height: auto !important;
	}
	.content >>> span{
		font-size: 16px !important;
	}
	.guide {
		float: left;
		width: 88%;
		background: white;
		padding: 0 6% 20px;
	}
	
	.guide_top {
		float: left;
		width: 100%;
		line-height: 40px;
	}
	
	.guide_top div {
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		font-size: 16px;
	}
	
	.guide_title {
		width: 100%;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 25px;
	}
	
	.guide_img {
		float: left;
		width: 100%;
		height: 100px;
		background: red;
		margin: 15px 0 0;
		border-radius: 5px;
		overflow: hidden;
	}
</style>


// WEBPACK FOOTER //
// src/components/Survey.vue